<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 12 : 0"
      class="premium-product-card transition-swing"
      :style="{ width: cardWidth || '240px', border: '1px solid #f1f5f9', borderRadius: '16px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }"
      @click="$router.push('/productdetailview/' + product.urlname)"
    >
      <!-- Image Section -->
      <div style="position: relative; background: white; padding: 16px; display: flex; justify-content: center; align-items: center; border-radius: 16px 16px 0 0; overflow: hidden;">
        <!-- Stock Status / Badges -->
        <div style="position: absolute; top: 12px; left: 12px; z-index: 2; display: flex; flex-direction: column; gap: 6px;">
          <div v-if="product.status == 'Inactive' || product.quantity < product.minimumOrderQuantity" style="background: #fee2e2; color: #ef4444; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
            Out of Stock
          </div>
          <div v-if="product.offer > 0" style="background: #3EA56E; color: white; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
            {{ product.offer }}% OFF
          </div>
        </div>
        
        <v-img
          v-if="product.photos && product.photos[0]"
          :src="mediaURL + product.photos[0]"
          :lazy-src="mediaURL + product.photos[0]"
          height="180px"
          contain
          class="product-image-display"
          :class="{ 'zoom-image': hover }"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#3EA56E" size="20"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-img
          v-else
          src="./../../../assets/Images/noimage.png"
          height="180px"
          contain
        ></v-img>
      </div>

      <!-- Info Section -->
      <v-card-text class="pa-4 text-left d-flex flex-column" style="flex-grow: 1;">
        <!-- Category Tag -->
        <!-- <div style="display: inline-flex; align-items: center; background: rgba(62, 165, 110, 0.08); padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; color: #3EA56E; margin-bottom: 12px; align-self: flex-start;">
          <v-icon left size="14" color="#3EA56E">mdi-leaf</v-icon>
          <span v-if="product.categoryId">{{ product.categoryId.name }}</span>
          <span v-else>Product</span>
        </div> -->

        <div class="product-title-text mb-2 text-truncate" style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 4px;">
          {{ product.productname }}
        </div>
        
        <!-- Rating -->
        <div class="rating-section d-flex align-center mb-2">
          <v-rating
            :value="product.rating"
            color="#F59E0B"
            background-color="#E2E8F0"
            dense
            readonly
            size="14"
          ></v-rating>
          <span class="review-text ml-1" v-if="product.totalReviews > 0" style="font-size: 12px; color: #94a3b8;">
            {{ product.totalReviews }} reviews
          </span>
        </div>

        <div style="flex-grow: 1;"></div>

        <!-- Price -->
        <div class="price-section d-flex align-center gap-2 mb-4 flex-wrap">
          <div style="font-size: 18px; font-weight: 700; color: #3EA56E;">
            ₹{{ product.offerPrice }}
            <span v-if="product.unit" style="font-size: 12px; font-weight: 500; color: #64748b;">/ {{ product.unit }}</span>
          </div>
          <div v-if="product.price != product.offerPrice" style="font-size: 13px; color: #94a3b8; text-decoration: line-through; margin-left: 8px;">
            ₹{{ product.price }}
          </div>
        </div>

        <!-- Actions -->
        <div style="display: flex; gap: 8px; align-items: center; margin-top: auto;">
          <v-btn 
            v-if="!product.incart"
            depressed 
            color="#3EA56E" 
            dark 
            style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 13px; height: 36px;"
            @click.stop="setDefault(product._id)"
            :disabled="product.status == 'Inactive' || product.quantity < product.minimumOrderQuantity"
          >
            <v-icon left size="16">mdi-cart-outline</v-icon>
            Add
          </v-btn>
          
          <v-btn 
            v-if="product.incart"
            depressed 
            color="#3EA56E" 
            dark 
            style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 13px; height: 36px;"
            @click.stop="$router.push('/cart')"
          >
            <v-icon left size="16">mdi-check</v-icon>
            In Cart
          </v-btn>

          <v-btn 
            icon 
            outlined 
            :color="product.inWishlist || product.inwishlist ? '#ef4444' : '#e2e8f0'" 
            style="border: 1px solid #e2e8f0; border-radius: 8px; width: 36px; height: 36px;"
            @click.stop="toggleWishlist(product)"
          >
            <v-icon size="16" :color="product.inWishlist || product.inwishlist ? '#ef4444' : '#64748b'">{{ product.inWishlist || product.inwishlist ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import axios from "axios";
export default {
  props: ["product", "cardWidth"],
  data() {
    return {};
  }, 
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  }, 
  methods: {
    setDefault(item) {
      this.$emit("stepper", {
        ref: "addtocart",
        productId1: item,
      });
    },
    toggleWishlist(item) {
      const inWishlist = item.inWishlist || item.inwishlist;
      const url = inWishlist ? "/WishList/Remove" : "/WishList/Addorupdate";

      var headers1 = {};
      var data = {
        productid: item._id
      };

      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: url,
        data: data,
        headers: headers1,
      })
      .then((response) => {
        if (response.data.status) {
          this.$set(item, 'inWishlist', !inWishlist);
          this.$set(item, 'inwishlist', !inWishlist);
          this.$store.commit("changeWishlist", response.data.wishlistcount);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>
.product-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: default;
  border: 1px solid #f0f0f0 !important;
  background-color: white !important;
}

.image-wrapper {
  overflow: hidden;
  position: relative;
}

.product-image-display {
  transition: transform 0.5s ease;
  cursor: pointer;
}

.zoom-image {
  transform: scale(1.08);
}

.offer-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff4747;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: 'ibmsemibold', sans-serif;
  font-size: 10px;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1px);
  z-index: 2;
}

.hover-action-btn {
  transform: translateY(20px);
  animation: slideUp 0.3s forwards;
}

@keyframes slideUp {
  to { transform: translateY(0); }
}

.product-title-text {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 14px;
  color: #2c3e50;
  cursor: pointer;
  transition: color 0.2s;
}

.product-title-text:hover {
  color: #3ea56e;
}

.price-section {
  font-family: 'ibmsemibold', sans-serif;
}

.offer-price {
  font-size: 16px;
  color: #3ea56e;
}

.original-price {
  font-size: 12px;
  color: #95a5a6;
  text-decoration: line-through;
}

.unit-label {
  font-size: 11px;
  font-family: 'ibmlight', sans-serif;
}

.review-text {
  font-size: 11px;
  color: #7f8c8d;
  font-family: 'ibmlight', sans-serif;
}

.transition-swing {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>e>